import InfoCircle from 'svg/InfoCircle';
import Button, { ButtonText } from 'components/Button';
import { CompleteCtaProps } from '../../props';

const CompleteCta = ({ title, chances, onInfoClick, onCtaClick, ctaText }: CompleteCtaProps) => {
  return (
    <div className="relative flex flex-col items-center justify-center text-center">
      <span className="typography-product-subheading text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
        {title}
      </span>
      <span className="typography-product-card-title-desktop mb-ds-xl mt-ds-sm text-color-brand-primary">
        {chances}% completion
      </span>
      <div className="mt-auto">
        <Button variant="primary" onClick={onCtaClick} className="w-fit" size="sm">
          {ctaText}
        </Button>
        <ButtonText className="mx-auto mt-ds-md flex items-center gap-2" onClick={onInfoClick}>
          <InfoCircle className="h-3.5 w-3.5" />
          Info
        </ButtonText>
      </div>
    </div>
  );
};

export default CompleteCta;
